import { flow } from 'lodash'
import webBiLogger from '@wix/web-bi-logger'
import { objectFilterMutator, undefinedFilterMutator } from '../../bi'
import type { BiEvent, LoggerAdapter } from '../types'

export const createBiLogger = () =>
  webBiLogger
    .factory()
    .withTransformer(flow(objectFilterMutator(), undefinedFilterMutator()))
    .logger()

export const biAdapter = (): LoggerAdapter => {
  const logger = createBiLogger()
  return {
    bi: (event: BiEvent) => {
      logger.report(event)
    },
    updateContext: context => {
      if ('biDefaults' in context && context.biDefaults) {
        logger.updateDefaults(context.biDefaults)
      }
    },
  }
}
